// NavBar4 — logo + nav links + button rows, with a mobile hamburger panel and a
// mobile-only combined Apply/Login CTA (the stacked Login + Apply buttons
// collapse into one button below the lg breakpoint).
// Fields here mirror exactly what NavBar4.tsx reads — no announcement bar,
// no CTA1/2/3 and no dropdown chrome (those belong to NavBar3).

export const NAVBAR_4_CONSTANTS = {
  DEFAULT_ROW: {
    id: "",
    background_color: "#ffffff",
    hamburger_icon: "",
    hamburger_icon_alt: "",
    logo_icon: "",
    logo_icon_alt: "",
    mobile_logo_icon: "",
    mobile_logo_icon_alt: "",
    nav_link_color: "",
    nav_link_hover_color: "#DB5803",
    sticky_to_top: false,
    /** Lead modal purple; empty in API still resolves in NavBar4 */
    mobile_hamburger_background: "#291973",
    /** Mobile menu panel — distinct from the white top bar */
    mobile_menu_background: "",
    mobile_combined_cta_label: "Apply/Login",
    mobile_combined_cta_background: "#291973",
    mobile_combined_cta_border_color: "#FFD6BB",
    status: true,
  },

  NAVBAR_FIELDS_CONFIG: [
    {
      fieldName: "background_color",
      label: "Background Color",
      value: "#ffffff",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Bar background (e.g. #ffffff)",
      required: false,
      defaultValue: "#ffffff",
    },
    {
      fieldName: "logo_icon",
      label: "Logo (desktop)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Main logo",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "logo_icon_alt",
      label: "Logo Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "mobile_logo_icon",
      label: "Logo (mobile)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Optional — falls back to desktop logo",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "mobile_logo_icon_alt",
      label: "Mobile Logo Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "show_hamburger",
      label: "Show Hamburger Menu on Mobile",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Show the hamburger icon on the mobile bar (hides the drawer when off)",
      defaultValue: true,
    },
    {
      fieldName: "hamburger_icon",
      label: "Hamburger Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Optional — defaults to icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "hamburger_icon_alt",
      label: "Hamburger Icon Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "nav_link_color",
      label: "Default nav link color",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Leave empty for theme default",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "nav_link_hover_color",
      label: "Nav link hover color",
      value: "#DB5803",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Default #DB5803 when empty",
      required: false,
      defaultValue: "#DB5803",
    },
    {
      fieldName: "sticky_to_top",
      label: "Stick to top on scroll (sits below Header 4 when both sticky)",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      required: false,
      defaultValue: false,
    },
    {
      fieldName: "mobile_hamburger_background",
      label: "Mobile — hamburger button background",
      value: "#291973",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Default #291973 when empty",
      required: false,
      defaultValue: "#291973",
    },
    {
      fieldName: "mobile_menu_background",
      label: "Mobile menu panel background (when hamburger open)",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "e.g. #f5f5f5 — empty uses light gray",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "mobile_combined_cta_label",
      label: "Mobile — Apply/Login button label",
      value: "Apply/Login",
      valueType: "string",
      filedType: "INPUT",
      placeholder: 'Default "Apply/Login" when empty',
      required: false,
      defaultValue: "Apply/Login",
    },
    {
      fieldName: "mobile_combined_cta_background",
      label: "Mobile — Apply/Login button background",
      value: "#291973",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Default #291973 when empty",
      required: false,
      defaultValue: "#291973",
    },
    {
      fieldName: "mobile_combined_cta_border_color",
      label: "Mobile — Apply/Login button border color",
      value: "#FFD6BB",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Default #FFD6BB when empty",
      required: false,
      defaultValue: "#FFD6BB",
    },
    {
      fieldName: "status",
      label: "Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],
};

export const MENU_ITEM_4_CONSTANTS = {
  DEFAULT_ROW: {
    id: "",
    parent_id: null,
    title: "",
    slug: "",
    url: "",
    status: true,
    priority: 1,
    text_color: "#000000",
    is_button: false,
    button_color: "#BE2330",
    button_border_color: "",
    button_font_size: "",
    is_cta: false,
  },

  MENU_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter menu title (e.g., MBA)",
      required: true,
      defaultValue: "",
    },
    {
      fieldName: "parent_id",
      label: "Parent Menu",
      value: null,
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select parent menu",
      required: false,
      defaultValue: null,
      options: [],
    },
    {
      fieldName: "slug",
      label: "Slug",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Auto-generated from title",
      defaultValue: "",
    },
    {
      fieldName: "url",
      label: "URL",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder:
        "/path or https://… (optional — ignored for clicks when Is CTA is on)",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "is_cta",
      label: "Is CTA",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder:
        "On = open lead capture popup instead of navigating (nav links & buttons)",
      required: false,
      defaultValue: false,
    },
    {
      fieldName: "priority",
      label: "Priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter display priority",
      required: true,
      defaultValue: 1,
    },
    {
      fieldName: "status",
      label: "Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable menu item",
      defaultValue: true,
    },
    {
      fieldName: "text_color",
      label: "Text color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Nav links & button label color",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "is_button",
      label: "Is Button",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Display as button",
      defaultValue: false,
    },
    {
      fieldName: "button_color",
      label: "Button background color",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Solid fill; leave empty for outline (Login) style",
      required: false,
      defaultValue: "#BE2330",
    },
    {
      fieldName: "button_border_color",
      label: "Button border color",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Outline / solid border (optional)",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "button_font_size",
      label: "Button font size",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. 14px, 0.875rem, 1rem",
      required: false,
      defaultValue: "",
    },
  ],

  TREE_CONFIG: {
    treeTitle: "Menu Item 4 — structure",
    treeIcon: "🌳",
    emptyMessage: "No menu items yet. Add your first one below.",

    itemDisplayFields: {
      primary: "title",
      secondary: "slug",
      statusField: "status",
      statusInactiveLabel: "Inactive",
      childrenField: "children",
    },

    fieldMappings: {
      id: "id",
      parentId: "parent_id",
      orderIndex: "priority",
      title: "title",
      slug: "slug",
      url: "url",
      isActive: "status",
    },

    parentFieldName: "parent_id",
    parentTopLevelValue: "null",
    parentTopLevelLabel: "-- Top Level --",

    formLabels: {
      addNew: "➕ Add menu link",
      edit: "✏️ Edit item",
      saveButton: "Add Menu Item",
      updateButton: "Update Menu Item",
      newButton: "New",
      cancelButton: "Cancel",
    },

    deleteConfirmation: (item: any) =>
      `Delete "${item.title}"? This will also delete all child items.`,

    requiresParentComponent: true,
    parentComponentName: "Navbar",
    parentIdFieldName: "navbar_id",
    childItemsFieldName: "menuItems",
    parentComponentTitle: "Navbar Settings",
    parentComponentSaveButtonText: "Save Navbar Settings",
    parentComponentCreateSuccessMessage: "Navbar created successfully",
    parentComponentUpdateSuccessMessage: "Navbar settings saved successfully",
    requireParentMessage:
      "Please save the Navbar Settings first before creating menu items. The navbar must be created before you can add menu items.",
    parentComponentMessage: {
      title: "Navbar Not Created Yet",
      description:
        "Please save the Navbar Settings above before adding menu items.",
    },
  },
};
